import React, { useState, useEffect } from 'react';

const TextArea = props => {
	const [htmlId, setHtmlId] = useState(`question-${props.question.id}`);
	const [selectedValue, setSelectedValue] = useState();
	const [cssClass, setCssClass] = useState(props.cssClass ?? '');

	useEffect(() => {
		setSelectedValue(props.selectedValue)
	}, [props.selectedValue]);

	const handleChange = (e) => {
		setSelectedValue(e.target.value);
		props.onChange(e.target.value);
	};

	return (
		<>
			<div className={`cft-text ${cssClass} ${props.validationCssClass}`}>
				{props.question.showLabel && <label for={htmlId} >{props.question.label ?? props.question.name}{`${props.question.isRequired ? ' *' : ''}`}</label>}
				{props.validationMessage && props.validationCssClass && <span className="validation-message">{props.validationMessage}</span>}
				<textarea className={`form-control ${props.validationCssClass}`} id={htmlId} onInput={handleChange} rows="8">{selectedValue}</textarea>
			</div>
		</>
	);
}

export default TextArea;